import { render, staticRenderFns } from "./UserResources.vue?vue&type=template&id=37c49be1"
import script from "./UserResources.vue?vue&type=script&lang=js"
export * from "./UserResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports